// extracted by mini-css-extract-plugin
export default {"game":"Game_game__CEt+z","active":"Game_active__swony","cartActions":"Game_cartActions__FFAxi","moredetails":"Game_moredetails__-OQEh","opacityColor":"Game_opacityColor__KsqSP"};